import React from 'react';
import Products from '../features/product-list/product-components/Products';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Products />
      <Footer />
    </>
  );
};

export default Home;
